import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Re-enable Firestore - we need it for creator data
localStorage.removeItem('firestoreDisabled');
console.log('Firestore re-enabled for creator data');

// Global error handler for Firestore internal errors
window.addEventListener('error', (event) => {
  if (event.error && event.error.message && event.error.message.includes('INTERNAL ASSERTION')) {
    console.warn('Caught Firestore internal assertion error globally:', event.error);
    // Prevent the error from crashing the app
    event.preventDefault();
    event.stopPropagation();
    
    // Ensure Firestore is disabled
    localStorage.setItem('firestoreDisabled', 'true');
    console.log('Firestore disabled due to internal errors');
  }
});

// Global unhandled promise rejection handler
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && event.reason.message.includes('INTERNAL ASSERTION')) {
    console.warn('Caught Firestore internal assertion error in promise rejection:', event.reason);
    // Prevent the error from crashing the app
    event.preventDefault();
    
    // Ensure Firestore is disabled
    localStorage.setItem('firestoreDisabled', 'true');
    console.log('Firestore disabled due to internal errors in promise rejection');
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
